export const GLUE42_FDC3_INTENTS_METHOD_PREFIX = "Tick42.FDC3.Intents.";

export const INTENTS_RESOLVER_INTEROP_PREFIX = "T42.Intents.Resolver.Control.";

export const INTENTS_RESOLVER_APP_NAME = "intentsResolver";

export const DEFAULT_RESOLVER_RESPONSE_TIMEOUT = 60000;

export const ADDITIONAL_BRIDGE_OPERATION_TIMEOUT = 30000;

export const INTENTS_RESOLVER_WIDTH = 400;

export const INTENTS_RESOLVER_HEIGHT = 440;

// JS setTimeout max value - When delay is larger than 2147483647 or less than 1, the delay will be set to 1
export const MAX_SET_TIMEOUT_DELAY = 2147483647;
